import * as React from 'react'

import { observer } from 'mobx-react'

import FiltersSelector from 'modules/reports/components/Editor/Carcasa/FormFields/FiltersSelector'
import type { ReportEditorStore } from 'modules/reports/lib/Store'

import Area from './Types/Area'
import Bars from './Types/Bars'
import Lines from './Types/Lines'
import NumericMetric from './Types/NumericMetric'
import Pie from './Types/Pie'
import Scatterplot from './Types/Scatterplot'
import Table from './Types/Table'

interface Props {
  store: ReportEditorStore
}

const REPORT_TYPES: Record<string, React.ComponentType<Props>> = {
  bars: Bars,
  pie: Pie,
  numeric_metric: NumericMetric,
  lines: Lines,
  scatterplot: Scatterplot,
  table: Table,
  area: Area,
}

interface FormViewProps {
  store: ReportEditorStore
}

const FormView = ({ store }: FormViewProps) => {
  const type = store.reportStruct.type

  if (!store.reportStruct.chartSelected) return null

  const ReportTypeForm = REPORT_TYPES[type]

  if (!ReportTypeForm) {
    throw Error(`Unknown chart type: ${type}`)
  }

  return (
    <>
      <ReportTypeForm store={store} />
      <FiltersSelector store={store} />
    </>
  )
}

export default observer(FormView)
